<div class="vaPassenger pax-element-wrapper blue-theme" ngbDropdown>
  <a
    (click)="showPax($event)"
    (keydown)="openPassenger($event)"
    aria-describedby="pax-info"
    aria-label="Expand child passenger dropdown"
    aria-label="Passenger dropdown"
    class="pax-wrapper downArrow-icon"
    href="javascript:void(0)"
    id="passenger"
    ng-bind="totalCount"
    role="listbox"
  >
    <span class="sr-only" id="pax-info">
      Use enter to open this dropdown. Currently Selected
      {{ totalPassengerDescription }}
    </span>
    <div class="paxDetailDesc">
      <span
        *ngFor="let pax of vaPassenger; let i = index"
        [innerHTML]="
          pax.passengerCount > 0
            ? getDesc(
                pax.passengerCount,
                pax.passengerSingular,
                pax.passengerPlural
              )
            : ''
        "
        ng-bind="pax.passengerCount"
      ></span>
    </div>
    <div
      [innerHTML]="
        totalCount > 1 ? totalCount + ' passengers' : totalCount + ' passenger'
      "
      class="paxCountDesc"
    ></div>
  </a>
  <ul
    aria-labelledby="dropdownBasic1"
    class="paxList hideOption pax-optionUL"
    ngbDropdownMenu
    role="listbox"
    tabindex="0"
  >
    <span class="sr-only" id="dropdownBasic1">
      There are 4 types of passengers: Adults, Young adults, Children and Lap
      infants. Controls for adding and removing each type of passengers are
      present
    </span>
    <div class="close-pax float-right" tabindex="-1">
      <a
        (click)="closePax($event)"
        (keydown)="closePassenger($event)"
        aria-describedby="cloxepax"
        aria-label="passenger dropdown close"
        class="va-close-img"
        href="javascript:void(0)"
        role="button"
      ></a>
      <span class="sr-only" id="cloxepax">
        Press enter to close the passenger dropdown
      </span>
    </div>
    <li
      *ngFor="let pax of vaPassenger; let i = index"
      class="pax-optionList pax-{{ pax.passengertypeId }}"
      role="option"
    >
      <div class="float-left paxDetails">
        <div class="paxTitle" tab-index="0">{{ pax.passengerTitle }}</div>
        <div class="pax-desc">
          <div
            [attr.aria-describedby]="pax.passengertypeId"
            class="paxType-desc"
            tabindex="0"
          >
            {{ pax.passengerDescription }}
            <span class="sr-only" id="{{ pax.passengertypeId }}">
              {{ pax.passengerTitle }} {{ pax.passengerDescription }}, Currently
              Selected {{ totalPassengerDescription }}
            </span>
          </div>
          <div *ngIf="pax.passengerToolTip" class="paxType-toolTip">
            <a
              #youngadultpaxHelp="ngcHelpModalDirective"
              (click)="youngadultpaxHelp?.openHelpModal()"
              [helpContent]="content?.tooltips?.get(pax.passengerToolTip)"
              [type]="'youngadultpax'"
              aria-haspopup="true"
              class="va-child-tooltip-icon icon-help circle-outline"
              href="javascript:void(0);"
              ngc-help-modal-directive
            >
              <span class="sr-only">
                Press enter to open {{ pax.passengerTitle }} tooltip
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="float-right paxCount">
        <div class="remove-pax" role="button" tabindex="2">
          <a
            (click)="removePax(pax.passengerCount, i, pax.passengerMinCount)"
            (keydown)="
              ($event.keyCode === 109 ||
              $event.keyCode === 189 ||
              $event.keyCode === 13
                ? 'removePax(pax.passengerCount, i, pax.passengerMinCount)'
                : '')
            "
            [ngClass]="
              (pax.passengerCount | number) === pax.passengerMinCount
                ? 'remove-img'
                : 'active-remove-img'
            "
            href="javascript:void(0)"
            ng-bind="pax.passengerCount"
            role="button"
            tabindex="-1"
          >
            <span class="sr-only">
              Remove {{ pax.passengerTitle }} passenger
            </span>
          </a>
        </div>
        <div
          [ngClass]="{ disabledState: (pax.passengerCount | number) === 0 }"
          aria-live="assertive"
          class="paxNum"
          ng-bind="pax.passengerCount"
        >
          {{ pax.passengerCount | number }}
          <input
            id="{{ pax.passengertypeId }}"
            name="paxTypes[{{ i }}]"
            type="hidden"
            value="{{ pax.passengerCount }}"
          />
        </div>
        <div class="add-pax" role="button" tabindex="3">
          <a
            (click)="addPax(pax.passengerCount, i, pax.passengerMaxCount)"
            (keydown)="
              ($event.keyCode === 107 ||
              $event.keyCode === 187 ||
              $event.keyCode === 13
                ? 'addPax(pax.passengerCount, i, pax.passengerMaxCount)'
                : '')
            "
            (keydown)="onPaxTabKey($event, i)"
            [ngClass]="
              (pax.passengerCount | number) === pax.passengerMaxCount
                ? 'add-img'
                : 'active-add-img'
            "
            href="javascript:void(0)"
            ng-bind="pax.passengerCount"
            role="button"
          >
            <span class="sr-only">Add {{ pax.passengerTitle }} passenger</span>
          </a>
        </div>
      </div>
    </li>
  </ul>
</div>
